/** 询价类型 */
export const INQUIRY_TYPE_OPTIONS = [
  {
    label: "生产性物料（原料+辅料）",
    value: "PRODUCTION_RAW_AUXILIARY",
  },
  {
    label: "生产性物料（包材+非实验MRO）",
    value: "PRODUCTION_PACKAGING_MRO",
  },
  {
    label: "非生产性物料（实验室MRO）",
    value: "NON_PRODUCTION_LAB_MRO",
  },
];
